var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMouse({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 51,
    viewBox: "0 0 39 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_736_4246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.525 0H16.0893C7.20297 0 0 7.13402 0 15.9375V35.0625C0 43.866 7.20297 51 16.0893 51H22.525C31.4123 51 38.6143 43.865 38.6143 35.0625V15.9375C38.6143 7.13402 31.4143 0 22.525 0ZM33.7875 15.9375V17.5312H21.7205V4.78125H22.525C28.7495 4.7932 33.7774 9.77367 33.7875 15.9375ZM16.0893 4.78125H16.8937V17.5312H4.82679V15.9375C4.83986 9.77367 9.86776 4.7932 16.0893 4.78125ZM22.525 46.2188H16.0893C9.86675 46.2063 4.83684 41.2253 4.82679 35.0625V22.3125H33.7875V35.0625C33.7774 41.2283 28.7495 46.2088 22.525 46.2188Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_736_4246"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.6143,
    height: 51,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouse);
export default __webpack_public_path__ + "static/media/mouse.665d86d2cbf26aca412b98bfcdaf8668.svg";
export { ForwardRef as ReactComponent };